// src/routes/talentScoutRoutes.js
// Talent Scout specific routes

import React from "react";

// Talent Scout page imports
import AllTalents from "../pages/talentScout/allTalents";
import GetPlayer from "../pages/talentScout/getPlayer";
import GetTeam from "../pages/talentScout/getTeam";
import GetOrganization from "../pages/talentScout/getOrganization";

// Talent Scout routes
export const talentScoutRoutes = [
  // Main talent discovery page
  { path: "/talent-scout/all-talents", element: <AllTalents /> },
  
  // Individual entity detail pages
  { path: "/talent-scout/get-player/:id", element: <GetPlayer /> },
  { path: "/talent-scout/get-team/:id", element: <GetTeam /> },
  { path: "/talent-scout/get-organization/:id", element: <GetOrganization /> },
]; 